import { AttachmentBlockSpec } from '@blocksuite/hive-block-attachment';
import { BookmarkBlockSpec } from '@blocksuite/hive-block-bookmark';
import { CalloutBlockSpec } from '@blocksuite/hive-block-callout';
import { CodeBlockSpec } from '@blocksuite/hive-block-code';
import { DataViewBlockSpec } from '@blocksuite/hive-block-data-view';
import { DatabaseBlockSpec } from '@blocksuite/hive-block-database';
import { DividerBlockSpec } from '@blocksuite/hive-block-divider';
import { EdgelessTextBlockSpec } from '@blocksuite/hive-block-edgeless-text';
import { EmbedExtensions } from '@blocksuite/hive-block-embed';
import { FrameBlockSpec } from '@blocksuite/hive-block-frame';
import { ImageBlockSpec } from '@blocksuite/hive-block-image';
import { LatexBlockSpec } from '@blocksuite/hive-block-latex';
import { ListBlockSpec } from '@blocksuite/hive-block-list';
import {
  EdgelessNoteBlockSpec,
  NoteBlockSpec,
} from '@blocksuite/hive-block-note';
import { ParagraphBlockSpec } from '@blocksuite/hive-block-paragraph';
import {
  EdgelessSurfaceBlockAdapterExtensions,
  EdgelessSurfaceBlockSpec,
  PageSurfaceBlockSpec,
  SurfaceBlockAdapterExtensions,
} from '@blocksuite/hive-block-surface';
import {
  EdgelessSurfaceRefBlockSpec,
  PageSurfaceRefBlockSpec,
} from '@blocksuite/hive-block-surface-ref';
import { TableBlockSpec } from '@blocksuite/hive-block-table';
import {
  brushToMarkdownAdapterMatcher,
  brushToPlainTextAdapterMatcher,
} from '@blocksuite/hive-gfx-brush';
import {
  connectorToMarkdownAdapterMatcher,
  connectorToPlainTextAdapterMatcher,
} from '@blocksuite/hive-gfx-connector';
import {
  groupToMarkdownAdapterMatcher,
  groupToPlainTextAdapterMatcher,
} from '@blocksuite/hive-gfx-group';
import {
  mindmapToMarkdownAdapterMatcher,
  mindmapToPlainTextAdapterMatcher,
} from '@blocksuite/hive-gfx-mindmap';
import {
  shapeToMarkdownAdapterMatcher,
  shapeToPlainTextAdapterMatcher,
} from '@blocksuite/hive-gfx-shape';
import {
  textToMarkdownAdapterMatcher,
  textToPlainTextAdapterMatcher,
} from '@blocksuite/hive-gfx-text';
import { inlinePresetExtensions } from '@blocksuite/hive-inline-preset';
import {
  DefaultOpenDocExtension,
  DocDisplayMetaService,
  EditPropsStore,
  FontLoaderService,
} from '@blocksuite/hive-shared/services';
import type { ExtensionType } from '@blocksuite/store';

const elementToPlainTextAdapterMatchers = [
  groupToPlainTextAdapterMatcher,
  shapeToPlainTextAdapterMatcher,
  connectorToPlainTextAdapterMatcher,
  brushToPlainTextAdapterMatcher,
  textToPlainTextAdapterMatcher,
  mindmapToPlainTextAdapterMatcher,
];

const elementToMarkdownAdapterMatchers = [
  groupToMarkdownAdapterMatcher,
  shapeToMarkdownAdapterMatcher,
  connectorToMarkdownAdapterMatcher,
  brushToMarkdownAdapterMatcher,
  textToMarkdownAdapterMatcher,
  mindmapToMarkdownAdapterMatcher,
];

export const CommonBlockSpecs: ExtensionType[] = [
  inlinePresetExtensions,
  DocDisplayMetaService,
  EditPropsStore,
  LatexBlockSpec,
  ListBlockSpec,
  DatabaseBlockSpec,
  TableBlockSpec,
  DataViewBlockSpec,
  DividerBlockSpec,
  BookmarkBlockSpec,
  EmbedExtensions,
  AttachmentBlockSpec,
  CodeBlockSpec,
  ImageBlockSpec,
  ParagraphBlockSpec,
  DefaultOpenDocExtension,
  FontLoaderService,
  CalloutBlockSpec,
  FrameBlockSpec,

  elementToPlainTextAdapterMatchers,
  elementToMarkdownAdapterMatchers,
].flat();

export const PageFirstPartyBlockSpecs: ExtensionType[] = [
  CommonBlockSpecs,
  NoteBlockSpec,
  PageSurfaceBlockSpec,
  PageSurfaceRefBlockSpec,

  ...SurfaceBlockAdapterExtensions,
].flat();

export const EdgelessFirstPartyBlockSpecs: ExtensionType[] = [
  CommonBlockSpecs,

  EdgelessNoteBlockSpec,
  EdgelessSurfaceBlockSpec,
  EdgelessSurfaceRefBlockSpec,
  EdgelessTextBlockSpec,

  ...EdgelessSurfaceBlockAdapterExtensions,
].flat();
